<template>
  <ul v-if="showBubble" class="vbuy-dynamic" :class="{ 'in-app': env.isVivoApp }" aria-hidden="true">
    <li v-html="bubbleHtml"></li>
  </ul>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import env from '@/utils/clientEnv'
import { getOrderBubble, grouponOrderBubble } from './api'
export default {
  name: 'Dynamic',
  computed: {
    ...mapState('detailv3', ['skuInfo']),
    ...mapGetters('detailv3', ['spuId', 'skuId', 'isQuickBuy', 'isAtmosphere', 'isGroup']),
    // 判断是否需要显示
    showBubble() {
      // 避免切换规格
      return this.bubbleHtml && ((this.isQuickBuy && this.isAtmosphere) || this.isGroup)
    }
  },
  data() {
    return {
      env,
      list: [],
      // 动态插入抢购字符串
      bubbleHtml: '',
      myInterval: null
    }
  },
  created() {
    this.skuId && this.getDynamic()
  },
  methods: {
    /**
     * 初始化
     */
    async init() {
      let num = 0
      let i = 0
      let self = this
      function dyn() {
        if (i >= self.list.length) {
          i = 0
        }
        if (self.isGroup) {
          self.bubbleHtml = `<img src="${self.list[i].avatarImg}" alt="">${self.list[i].nickName}${self.list[i].desc}`
        } else {
          self.bubbleHtml = `<img src="${self.list[i].avatarImg}" alt="">${self.list[i].nickName}刚刚抢购了${self.list[i].buyNum}件`
        }
        i = i + 1
        num = num + 1
        // 每10次重新获取一次数据
        if (num % 10 === 0) {
          self.getDynamic(true)
        }
      }
      // 开始执行
      dyn()
      this.myInterval = setInterval(() => {
        if (this.showBubble) {
          // 避免出现图片、文字变换的状态
          self.bubbleHtml = ''
          self.$nextTick(dyn)
        } else {
          clearInterval(this.myInterval)
        }
      }, 3000)
    },

    /**
     * 获取抢购嘻嘻
     */
    async getDynamic(refresh) {
      // 参数
      let params = null
      // 调用的方法
      let fun = null
      // 有氛围抢购
      if (this.isQuickBuy && this.isAtmosphere) {
        params = {
          skuId: this.skuId
        }
        fun = getOrderBubble
      } else if (this.isGroup) {
        params = {
          spuId: this.spuId,
          promotionId: this.skuInfo.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityGroupon?.promotionId
        }
        // 拼购
        fun = grouponOrderBubble
      }
      if (params) {
        let data = await fun(params).catch(() => {})
        if (data) {
          if (this.isGroup) {
            this.list = data || []
            this.list.forEach(item => {
              if (item.owner == 1 && item.status == 0) item.desc = '刚刚发起了拼团'
              else if (item.owner == 1 && item.status == 0) item.desc = '刚刚拼团成功'
              else if (item.owner == 1 && item.status == 1) item.desc = '刚刚发起了拼团'
              else if (item.owner == 0 && item.status == 0) item.desc = '刚刚参与了拼团'
              else if (item.owner == 0 && item.status == 1) item.desc = '刚刚拼团成功'
            })
          } else {
            this.list = data.actOrderBubbles || []
          }
          !refresh && this.init()
        }
      }
    }
  },
  watch: {
    skuId(val) {
      if (val) {
        this.list = []
        this.bubbleHtml = ''
        clearInterval(this.myInterval)
        this.myInterval = null
        this.$nextTick(() => {
          this.getDynamic()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
